import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { ConceptFamilyModel } from './conceptfamily.model';
import { environment } from '../../../../environments/environment';
import { ApiResponse } from '../../../models/base';

const LIST_ENDPOINT = '/concepts/categories';

interface ApiMessageResponse {
  message: string;
}

@Injectable({
  providedIn: 'root',
})
export class ConceptFamilyService {
  conceptFamilyList: ConceptFamilyModel[] = [];

  constructor(private http: HttpClient) {}

  addData(conceptfamily: ConceptFamilyModel): Promise<ConceptFamilyModel> {
    return firstValueFrom(
      this.http.post<ApiResponse<ConceptFamilyModel>>(environment.apiUrl + LIST_ENDPOINT, conceptfamily)
    ).then((response) => response.data);
  }

  deleteData(uid: string): Promise<string> {
    return firstValueFrom(
      this.http.delete<ApiMessageResponse>(environment.apiUrl + LIST_ENDPOINT + `/${uid}`)
    ).then((response) => response.message);
  }

  editData(uid: string, conceptfamily: ConceptFamilyModel): Promise<ConceptFamilyModel> {
    return firstValueFrom(
      this.http.put<ApiResponse<ConceptFamilyModel>>(
        environment.apiUrl + LIST_ENDPOINT + `/${uid}`,
        conceptfamily
      )
    ).then((response) => response.data);
  }

  loadData(uid: string): Promise<ConceptFamilyModel> {
    return firstValueFrom(
      this.http.get<ApiResponse<ConceptFamilyModel>>(environment.apiUrl + LIST_ENDPOINT + `/${uid}`)
    ).then((response) => response.data);
  }

  getList(): Promise<ConceptFamilyModel[]> {
    return firstValueFrom(
      this.http.get<ApiResponse<ConceptFamilyModel[]>>(environment.apiUrl + LIST_ENDPOINT)
    ).then((response) => response.data);
  }
}